import type { IconNames } from "mapiq-atoms";

import { Icon } from "@atoms";

type PersonConnectionStatusProps = {
  icon: IconNames;

  label: string;
};

// Has the size of a small button, so it can take the button's place, but there is nothing to click
export const PersonConnectionStatus = ({ icon, label }: PersonConnectionStatusProps) => {
  return (
    <span className="flex items-center gap-1 rounded-md border-2 border-transparent bg-mapiq-black-800*/[0.04] px-4 py-[7px] text-[15px] font-semibold leading-none text-mapiq-black-800*">
      <Icon
        aria-hidden
        icon={icon}
        size="15px"
        color="currentColor"
      />
      {label}
    </span>
  );
};
